module.exports = "/assets/data/d81fbff0c2ebd321dcfa5b60b0a523e2-LL53.data.json";